import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'knhc-footer',
  templateUrl: 'knhc-footer.component.html',
  styleUrl: 'knhc-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class KnhcFooterComponent {
  protected copyrightYear = new Date().getFullYear();
  private currentUrl: string | undefined;
  private location = inject(Location);

  constructor() {
    this.location.onUrlChange((url) => {
      this.currentUrl = url.split('?')[0];
    });
  }

  public currentPage(pageUrl: string): boolean {
    return this.currentUrl === pageUrl;
  }

  public createError = () => {
    throw new Error('This is a test error, did it work?');
  };
}
